import { styled } from "../../../theme";
export const ItemLabel = styled.label `
  display: inline-flex;
  flex-direction: row;
  padding-top: 5px;
  padding-left: 5px;
  margin-bottom: 0.625em;
  border: 1px solid transparent;
  cursor: pointer;

  &:last-of-type {
    margin-bottom: 0;
  }

  &:focus {
    border-color: ${({ theme }) => theme.color.fillInfo};
    outline: none;
  }

  ${({ disabled }) => disabled &&
    `
    cursor: not-allowed;

    &[disabled] span {
      opacity: 0.5;

      span {
        opacity: 1;
      }
    }

    &[disabled] * {
      cursor: not-allowed;
    }
  `}
`;
